import { Injectable, computed, signal } from '@angular/core';

/**
 * Full-page bootstrap loading (auth / book load).
 * Prefer this over LoadingOverlay for entry flows; keep the overlay for
 * in-app actions (upload, edit, etc.).
 *
 * Contract: `show()` at the start of the flow; `hide()` on redirect errors.
 * On success, leave visible so the book resolver can take over and `hide()`.
 */
@Injectable({
  providedIn: 'root'
})
export class AppBootstrapLoadingService {
  private readonly visible = signal(false);

  readonly isLoading = computed(() => this.visible());

  show(): void {
    this.visible.set(true);
  }

  hide(): void {
    this.visible.set(false);
  }
}
